import Link from 'next/link';

export const MenuLink = (link: string, label: string, nextJsLink: boolean) => {
    if (nextJsLink) return <Link href={link}>{label}</Link>;
    else return <a href={link}>{label}</a>;
};
